import { useEffect, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { usePsychologistContext } from '../contexts/PsychologistContext';

/**
 * Carga a la psicóloga en el contexto al entrar a la app mobile. En la web lo dispara la primera pantalla que lo necesita
 * (Agenda, Perfil, `AppShell`); la app mobile no tiene ninguna de esas, y sin esto las vistas que dependen de ella (la
 * semana, la zona horaria, el saludo) quedan sin datos. Un solo intento por id: si falla, las vistas usan sus respaldos.
 */
export function useLoadPsychologist(): void {
  const { psychologist, loadPsychologist } = usePsychologistContext();
  const { psychologistId } = useAuth();
  const attemptedRef = useRef<string | null>(null);

  useEffect(() => {
    if (psychologist || !psychologistId || attemptedRef.current === psychologistId) return;
    attemptedRef.current = psychologistId;
    loadPsychologist(psychologistId).catch(() => {
      /* sin datos de la psicóloga las vistas siguen funcionando con sus valores por defecto */
    });
  }, [psychologist, psychologistId, loadPsychologist]);
}
